export default {
  INCORECT_BILLING_DETAILS: 'incorrect_billing_details',
  BILLING_PROFILE_ALREADY_EXISTS: 'billing_profile_already_exists',
  FIELD_VALIDATION_FAILURE: 'field_validation_failure',
  UNKNOWN_ERROR: 'unknown_error',
};
